import { PayloadAction, Draft } from "@reduxjs/toolkit";
import { PaginationDto } from "../../shared/dtos/common/PaginationDto";

// --- List-Only Factory (For Logs, Codes, and Lookups) ---

export interface ListState<T> {
  items: T[];
  pagination: Partial<PaginationDto>;
  loading: boolean;
  error: string | null;
}

export const getInitialListState = <T>(): ListState<T> => ({
  items: [],
  pagination: {},
  loading: false,
  error: null,
});

export interface ListReducers<T> {
  setLoading: (state: Draft<ListState<T>>) => void;
  setError: (
    state: Draft<ListState<T>>,
    action: PayloadAction<string | null>,
  ) => void;
  setItems: (state: Draft<ListState<T>>, action: PayloadAction<T[]>) => void;
  setPagination: (
    state: Draft<ListState<T>>,
    action: PayloadAction<Partial<PaginationDto>>,
  ) => void;
}

export const generateListReducers = <T>(): ListReducers<T> => ({
  setLoading(state) {
    state.loading = true;
    state.error = null;
  },
  setError(state, action) {
    state.loading = false;
    state.error = action.payload;
  },
  setItems(state, action) {
    state.loading = false;
    state.items = action.payload as unknown as Draft<T>[];
  },
  setPagination(state, action) {
    state.pagination = action.payload as unknown as Draft<
      Partial<PaginationDto>
    >;
  },
});
